export function triggerEvent(element, event_name = '', args = {}) {
  let event;
  if( document.createEvent ) {
    event = document.createEvent("HTMLEvents");
    event.initEvent(event_name, true, true);
  } else {
    event = document.createEventObject();
    event.eventType = event_name;
  }

  event.eventName = event_name;
  event.SmArgs = args;

  if( document.createEvent ) {
    element.dispatchEvent(event);
  } else {
    element.fireEvent("on" + event.eventType, event);
  }
}

export function isScrolledIntoView(item, offset = 0) {
  const doc = document.documentElement;
  const scroll = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  const bottom = scroll + window.innerHeight + offset;

  const elemTop = item.getBoundingClientRect().top - document.body.getBoundingClientRect().top;

  return ((elemTop >= scroll) && (elemTop <= bottom));
}

export function handleVideoAspectRatio() {
  const imageElementsDekstop = document.querySelectorAll('.video__thumbnail--desktop');
  const imageElementsMobile = document.querySelectorAll('.video__thumbnail--mobile');

  if(imageElementsDekstop) {
    imageElementsDekstop.forEach(imageElement => {
      setVideoAspectRatio(imageElement);
    });
  }

  const mediaQuery = window.matchMedia('(max-width: 991px)');
  if (mediaQuery.matches && imageElementsMobile) {
    imageElementsMobile.forEach(imageElement => {
      setVideoAspectRatio(imageElement);
    });
  }
}

export function setVideoAspectRatio(imageElement) {
  const width = imageElement.width;
  const height = imageElement.height;
  const videoElement = imageElement.closest('.video__player-container');
  videoElement.style.aspectRatio = `${width}/${height}`;
}
